<template>
  <ul ref="element" class="icons" :class="{ scrollable: scrollable }">
    <li v-if="scrollable" class="spacer" />
    <li
      v-for="(trophy, index) in trophies"
      :key="trophy.id"
      ref="items"
      class="icons-item"
    >
      <DialogTrophiesIconsItem
        :ready="completedStates[index]"
        :trophy="trophy"
        :medias="medias"
        :index="index"
        @select="emit('select', index)"
        @update-position="
          (index, position) => emit('updatePosition', index, position)
        "
      />
    </li>
    <li v-if="scrollable" class="spacer" />
  </ul>
</template>
<script setup lang="ts">
// @ts-ignore
import { spring } from 'vue3-spring';
import { gsap } from 'gsap';

interface Props {
  trophies: TrophySchema[];
  medias: Map<string, MediaSchema>;
}

const props = defineProps({
  trophies: null,
  medias: null
});

const emit = defineEmits(["complete", "scroll", "select", "updatePosition"]);

const scrollable = computed(() => props.trophies.length > 2);

const element = ref();

const itemRefs = useTemplateRef('items');

const completedStates = ref<boolean[]>([]);

props.trophies.forEach((item, index) => {
  completedStates.value[index] = false;
});

const _completeItem = (index) => {
  completedStates.value[index] = true;
};

const _complete = () => {
  emit('complete');
};

const initAnimation = () => {
  const tl = gsap.timeline({ delay: 0, onComplete: _complete });

  for (let index = 0; index < itemRefs.value.length; ++index) {
    tl.fromTo(
      itemRefs.value[index],
      {
        x: 0,
      },
      {
        x: 0,
        duration: 0.1 + index * 0.05,
        onComplete: _completeItem,
        onCompleteParams: [index],
      },
      index * 0.3
    );
  }
};

const { x: scrollX } = useScroll(element);

watchEffect(() => {
  emit('scroll', scrollX.value);
});

onMounted(() => {
  requestAnimationFrame(() => {
    initAnimation();
  });
});
</script>
<style lang="scss" scoped>
.icons {
  display: flex;
  z-index: 1;
  justify-content: center;
  width: stretch;

  // padding: 4rem 0 0;
  overflow: visible;
  overflow-x: scroll;
  gap: var(--gap_l);
  @include scrollbars(3rem, var(--color_neutral_0), var(--color_neutral_0));
  &.scrollable {
    justify-content: flex-start;
  }
  li {
    flex: 0 0 auto;
  }
}

.spacer {
  width: var(--gap_l); // used for offset scroll
}
</style>
